export default "__VITE_ASSET__90914f84__"